(() => {
  const initTabs = (root) => {
    root.querySelectorAll("[data-velvet-tabs]").forEach((tabs) => {
      if (tabs.dataset.initialized === "true") return;
      tabs.dataset.initialized = "true";

      const buttons = [...tabs.querySelectorAll("[data-tab-button]")];
      const panels = [...tabs.querySelectorAll("[data-tab-panel]")];

      const activate = (id, focus = false) => {
        buttons.forEach((button) => {
          const active = button.dataset.tabButton === id;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-selected", String(active));
          button.tabIndex = active ? 0 : -1;
          if (active && focus) button.focus();
        });

        panels.forEach((panel) => {
          const active = panel.dataset.tabPanel === id;
          panel.classList.toggle("is-active", active);
          panel.hidden = !active;
        });
      };

      buttons.forEach((button, index) => {
        button.addEventListener("click", () => activate(button.dataset.tabButton));
        button.addEventListener("keydown", (event) => {
          if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === "ArrowRight") nextIndex = (index + 1) % buttons.length;
          if (event.key === "ArrowLeft") nextIndex = (index - 1 + buttons.length) % buttons.length;
          if (event.key === "Home") nextIndex = 0;
          if (event.key === "End") nextIndex = buttons.length - 1;
          activate(buttons[nextIndex].dataset.tabButton, true);
        });
      });
    });
  };

  const init = (root = document) => initTabs(root);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
